const toBaseUrl = (value: string): string => value.trim().replace(/\/+$/, '')

export const SITE_URL = toBaseUrl(import.meta.env.VITE_SITE_URL)

export const APP_URL = toBaseUrl(import.meta.env.VITE_APP_URL)
